import {LANGUAGES, uiText} from "../utils/videoLanguage";

// Segmented EN / ES control for the video catalog.
//
// Deliberately styled like the Phone/Email switch on the login screen -- the
// learner has already met that control, and this is the same kind of choice
// (two mutually exclusive modes, one always active).
//
// `options` is the set actually present in the catalog, so this renders only
// the languages that have content. The dashboard hides the whole control when
// there is only one.
const LanguageToggle = ({value, options = LANGUAGES, onChange}) => (
  <div
    className="inline-flex items-center rounded-full bg-slate-100 p-1"
    role="group"
    aria-label={uiText("Video language", value)}
  >
    {options.map((lang) => {
      const active = lang.code === value;
      return (
        <button
          key={lang.code}
          type="button"
          onClick={() => onChange(lang.code)}
          // aria-pressed (not aria-selected): these are toggle buttons in a
          // group, not tabs -- there is no tabpanel behind them.
          aria-pressed={active}
          className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-300 ${
            active
              ? "bg-slate-900 text-white shadow-sm"
              : "text-slate-600 hover:text-slate-900"
          }`}
        >
          {lang.label}
        </button>
      );
    })}
  </div>
);

export default LanguageToggle;
